import React from 'react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '@/utils';
import { Mail, MessageSquare } from 'lucide-react';
import PublicShell from '@/components/public/PublicShell';

export default function Contact() {
  return (
    <PublicShell>
      <h1 className="text-4xl font-bold text-slate-900 mb-4">Contact Us</h1>
      <p className="text-slate-600 mb-8">Questions about screening, pricing or your account? We're happy to help.</p>
      <div className="grid sm:grid-cols-2 gap-4">
        <a href="mailto:info@worldcheck360.com" className="bg-white border border-slate-200 rounded-lg p-6 hover:border-rose-300">
          <Mail className="w-6 h-6 text-rose-500 mb-3" />
          <p className="font-semibold text-slate-900">Email</p>
          <p className="text-sm text-slate-600">info@worldcheck360.com</p>
        </a>
        <Link to={createPageUrl('ContactSales')} className="bg-white border border-slate-200 rounded-lg p-6 hover:border-rose-300">
          <MessageSquare className="w-6 h-6 text-rose-500 mb-3" />
          <p className="font-semibold text-slate-900">Talk to Sales</p>
          <p className="text-sm text-slate-600">Send us a message about Enterprise plans</p>
        </Link>
      </div>
    </PublicShell>
  );
}